import { Component } from '@angular/core';

@Component({
    standalone: false,
    selector: 'mport-root',
    templateUrl: './root-container.component.html'
})
export class RootContainerComponent {}
